import { RecurringDonation } from "../../types"
import { RecurringDonationState } from "./reducer"
import { getInitialStatus } from "../../utils/frequency"

const BASE_STATE = {
  validationErrors: {},
  liveValidate: false,
  apiErrorMessage: null,
}

export function initializeState(
  recurringDonation: RecurringDonation,
): RecurringDonationState {
  const initialStatus = getInitialStatus(recurringDonation)
  return {
    ...BASE_STATE,
    designations: recurringDonation.designations,
    selectedPaymentMethodId: recurringDonation.payment_method_id,
    initialPaymentMethodId: recurringDonation.payment_method_id,
    schedule: recurringDonation.schedule,
    status: initialStatus,
    initialStatus: initialStatus,
    releaseHoldAt: recurringDonation.release_hold_at,
    nextOccurrence: recurringDonation.next_occurrence,
  }
}
